var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"main",class:[(_vm.changeColorHeader ? 'background_color_1' : 'background_color_2')]},[(_vm.checkRoleAdmin)?_c('HeaderAdmin'):_vm._e(),_c('router-view',{staticClass:"main__content"}),_c('Notification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }